export default __webpack_public_path__ + "static/mobile_KV02-1b9044942bf6980433f9d7195bb2a965.mp4";